<script setup lang="ts">
import SectionCustomerCredits from './credits/SectionCustomerCredits.vue'
import ModalCustomerCredits from './modals/ModalCustomerCredits.vue'

defineOptions({
  name: 'CustomerCreditsPage',
})
</script>

<template>
  <SectionCustomerCredits />
  <ModalCustomerCredits />
</template>
